import WhatshotIcon from '@mui/icons-material/Whatshot';
import MusicNoteOutlinedIcon from '@mui/icons-material/MusicNoteOutlined';
import TheatersOutlinedIcon from '@mui/icons-material/TheatersOutlined';
import CellTowerOutlinedIcon from '@mui/icons-material/CellTowerOutlined';
import SportsEsportsOutlinedIcon from '@mui/icons-material/SportsEsportsOutlined';
import FeedOutlinedIcon from '@mui/icons-material/FeedOutlined';
import EmojiEventsOutlinedIcon from '@mui/icons-material/EmojiEventsOutlined';
import LightbulbOutlinedIcon from '@mui/icons-material/LightbulbOutlined';
import DiamondOutlinedIcon from '@mui/icons-material/DiamondOutlined';
import PodcastsIcon from '@mui/icons-material/Podcasts';

export const logo = "https://i.ibb.co/s9Qys2j/logo.png";

export const categories = [
  { name: "Trending", icon: <WhatshotIcon /> },
  { name: "Music", icon: <MusicNoteOutlinedIcon /> },
  { name: "Movies & TV", icon: <TheatersOutlinedIcon /> },
  { name: "Live", icon: <CellTowerOutlinedIcon /> },
  { name: "Gaming", icon: <SportsEsportsOutlinedIcon /> },
  { name: "News", icon: <FeedOutlinedIcon /> },
  { name: "Sports", icon: <EmojiEventsOutlinedIcon /> },
  { name: "Learning", icon: <LightbulbOutlinedIcon /> },
  { name: "Fashion & Beauty", icon: <DiamondOutlinedIcon /> },
  { name: "Podcasts", icon: <PodcastsIcon /> },
];

export const demoThumbnailUrl = "https://i.ibb.co/G2L2Gwp/API-Course.png";
export const demoChannelUrl = "/channel/UCmXmlB4-HJytD7wek0Uo97A";
export const demoVideoUrl = "/video/GDa8kZLNhJ4";
export const demoChannelTitle = "JavaScript Mastery";
export const demoVideoTitle =
  "Build and Deploy 5 JavaScript & React API Projects in 10 Hours - Full Course | RapidAPI";
export const demoProfilePicture = "http://dergipark.org.tr/assets/app/images/buddy_sample.png";
